import React, { useContext } from "react";
import {
  Box,
  Button,
  Heading,
  Text,
  Flex,
  Image,
  HStack,
  useToast,
} from "@chakra-ui/react";
import { FiShield, FiUsers } from "react-icons/fi";
import { HomeContext } from "../context/HomeContext";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import book from "../assets/book.pdf";
import IconCardXXL from "../components/layouts/IconCardXXL";
import Picto1 from "./picto/Picto1.png";
import Picto2 from "./picto/Picto2.png";
import Picto3 from "./picto/Picto3.png";
import Picto4 from "./picto/Picto3.png";

const Home = ({ onNext, onBack }) => {
  const [formData, setFormData, defaultFormData] = useContext(HomeContext);

  const navigate = useNavigate();
  const toast = useToast();

  // Vérifie si l'utilisateur est admin (bouton Administration conditionnel)
  const isAdmin = localStorage.getItem("admin") === "true";

  const handleStart = () => {
    navigate("client-info");
  };

  const handleStartITE = () => {
    navigate("ite");
  };

  const handleManuals = () => {
    navigate("manuals");
  };

  const handleReset = () => {
    localStorage.removeItem("formData");
    setFormData({ ...defaultFormData });
    toast({
      title: "Formulaire réinitialisé",
      description: "Le formulaire a été réinitialisé avec succès.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });
    window.location.reload();
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = book;
    link.setAttribute("download", "Nom_du_fichier_téléchargé");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleLogout = () => {
    localStorage.clear();
    toast({
      title: "Déconnexion réussie.",
      description: "Vous avez été déconnecté avec succès.",
      status: "info",
      duration: 5000,
      isClosable: true,
    });
    navigate("/");
    window.location.reload();
  };

  return (
    <Box width="full" px={20}>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        mb="30px"
        mt="20px"
      >
        <Image src={logo} w="150px" alt="Home Solution Logo" />
        <HStack spacing={3}>
          {/* Boutons admin-only : Clients + Administration */}
          {isAdmin && (
            <>
              <Button
                leftIcon={<FiUsers size={16} />}
                bg="white"
                color="#111827"
                border="1px solid"
                borderColor="#E5E7EB"
                borderRadius="8px"
                padding="8px 16px"
                fontWeight="600"
                fontSize="14px"
                _hover={{ bg: "#F9FAFB", borderColor: "#9CA3AF" }}
                _active={{ transform: "scale(0.98)" }}
                onClick={() => navigate("/clients")}
              >
                Clients
              </Button>
              <Button
                leftIcon={<FiShield size={16} />}
                bg="white"
                color="#111827"
                border="1px solid"
                borderColor="#E5E7EB"
                borderRadius="8px"
                padding="8px 16px"
                fontWeight="600"
                fontSize="14px"
                _hover={{ bg: "#F9FAFB", borderColor: "#9CA3AF" }}
                _active={{ transform: "scale(0.98)" }}
                onClick={() => navigate("/admin")}
              >
                Administration
              </Button>
            </>
          )}
          <Button
            w="150px"
            bgColor="#30C9FF"
            color="#FCFDFF"
            borderRadius="8px"
            padding="8px 16px"
            onClick={handleLogout}
          >
            Déconnexion
          </Button>
        </HStack>
      </Flex>
      <Box display={"flex"} flexDirection={"row"}>
        <Box display={"flex"} flexDirection={"column"}>
          <Heading fontSize={"28px"} mb={1} fontWeight={"510"}>
            Sélectionner votre objectif
          </Heading>
          <Text mb={8} color="#8C8C8C" fontWeight={"400"} fontSize="20px">
            Sélectionner une option pour continuer
          </Text>
        </Box>
      </Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        border="1.8px solid"
        borderColor={"#F4F4F4"}
        p={{ base: "30px", md: "30px 40px" }}
        gap="20px"
        borderRadius="8px"
        bg="#FCFDFF"
        align="center"
        justifyContent={"center"}
        bgColor={"white"}
      >
        <Box display={"flex"} flexDirection={"row"} justifyContent="center" gap="15px">
          {/* Section Configurer */}
          <Box>
            <Box
              display={"flex"}
              w={"260px"}
              mb={"20px"}
              h={"400px"}
              flexDirection={"column"}
              alignItems={"center"}
              borderRadius={"20px"}
              padding={"10px, 10px, 20px, 10px"}
              borderWidth={"1px"}
            >
              <IconCardXXL icon={Picto1}></IconCardXXL>
              <Text
                mt={"15px"}
                fontSize={"22px"}
                fontWeight="510"
                textTransform="uppercase"
              >
                CONFIGURER
              </Text>
              <Text
                fontWeight="510"
                mt={"8px"}
                fontSize={"18px"}
                mb={"30px"}
                color={"#8C8C8C"}
                textAlign="left"
              >
                Commencer votre étude
              </Text>
              <Button
                w="220px"
                bgColor="#30C9FF"
                color="#FCFDFF"
                borderRadius="8px"
                padding="8px 16px"
                onClick={handleStart}
              >
                COMMENCER
              </Button>
            </Box>
          </Box>

          {/* Section ITE */}
          <Box>
            <Box
              display={"flex"}
              w={"260px"}
              mb={"20px"}
              h={"400px"}
              flexDirection={"column"}
              alignItems={"center"}
              borderRadius={"20px"}
              padding={"10px, 10px, 20px, 10px"}
              borderWidth={"1px"}
            >
              <IconCardXXL icon={Picto4}></IconCardXXL>
              <Text
                mt={"15px"}
                fontSize={"22px"}
                fontWeight="510"
                textTransform="uppercase"
              >
                ITE
              </Text>
              <Text
                fontWeight="510"
                mt={"8px"}
                fontSize={"18px"}
                mb={"30px"}
                color={"#8C8C8C"}
                textAlign="left"
              >
                Commencer votre étude ITE
              </Text>
              <Button
                w="220px"
                bgColor="#30C9FF"
                color="#FCFDFF"
                borderRadius="8px"
                padding="8px 16px"
                onClick={handleStartITE}
              >
                COMMENCER
              </Button>
            </Box>
          </Box>

          {/* Section Réinitialiser */}
          <Box>
            <Box
              display={"flex"}
              w={"260px"}
              mb={"20px"}
              h={"400px"}
              flexDirection={"column"}
              alignItems={"center"}
              borderRadius={"20px"}
              padding={"10px, 10px, 20px, 10px"}
              borderWidth={"1px"}
            >
              <IconCardXXL icon={Picto2}></IconCardXXL>
              <Text
                mt={"15px"}
                fontSize={"22px"}
                fontWeight="510"
                textTransform="uppercase"
              >
                REINITALISER
              </Text>
              <Text
                fontWeight="510"
                mt={"8px"}
                fontSize={"18px"}
                mb={"30px"}
                color={"#8C8C8C"}
                textAlign="left"
              >
                Reinitialiser votre étude
              </Text>
              <Button
                w="220px"
                bgColor="#30C9FF"
                color="#FCFDFF"
                borderRadius="8px"
                padding="8px 16px"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>

          {/* Section Télécharger */}
          <Box>
            <Box
              display={"flex"}
              w={"260px"}
              mb={"20px"}
              h={"400px"}
              flexDirection={"column"}
              alignItems={"center"}
              borderRadius={"20px"}
              padding={"10px, 10px, 20px, 10px"}
              borderWidth={"1px"}
            >
              <IconCardXXL icon={Picto3}></IconCardXXL>
              <Text
                mt={"15px"}
                fontSize={"22px"}
                fontWeight="510"
                textTransform="uppercase"
              >
                TELECHARGER
              </Text>
              <Text
                fontWeight="510"
                mt={"8px"}
                fontSize={"18px"}
                mb={"30px"}
                color={"#8C8C8C"}
                textAlign="left"
              >
                Déscriptifs produits
              </Text>
              <Button
                w="220px"
                bgColor="#30C9FF"
                color="#FCFDFF"
                borderRadius="8px"
                padding="8px 16px"
                onClick={handleManuals}
              >
                DOWNLOAD
              </Button>
            </Box>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default Home;
